import React, { use } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { LotDetailContext } from "../../../../Contexts/LotDetailContext";

export function ExtruderField() {
    const { t } = useTranslation();
    const {
        lotDetail: {
            summary: {
                extruder
            }
        }
    } = use(LotDetailContext);

    return (
        <Form.Group as={Col} sm={6} className="col-sm-6" controlId="formExtruder">
            <Row>
                <Form.Label column sm={4}>{`${t('LotDetails.Summary.Extruder')}:`}</Form.Label>
                <Col sm={8}>
                    <Form.Control type="text" disabled value={extruder ?? ""} />
                </Col>
            </Row>
        </Form.Group>
    );
}